export default __webpack_public_path__ + "static/student-ffc02f88154cd36447abc628c99401e3.jpg";